function ModalWrapper({children, className}) {
  return (
    <section className="modal">
    <div className={`modal__content ${className}`}>
        {children}
    </div>
  </section>
  );
}
export default ModalWrapper;